import { useCallback } from 'react';
import { useAssistantFacade } from './useAssistantFacade';
import { useEventRefresher, useReadableEventRefresher } from '@zdrbm/zdr-react';
import { IConversation } from '../../model/Conversation';
import { IImage } from '../../../../infra';

export function useConversation(conversation: IConversation) {
    const facade = useAssistantFacade();
    const conversationId = conversation?.getId();

    const postUserMessage = useCallback(
        (content: string, image: IImage | undefined) => {
            if (conversationId) {
                facade.postUserMessage(conversationId, content, image);
            }
        },
        [facade, conversationId],
    );

    const repostLastUserMessage = useCallback(() => {
        if (conversationId) {
            facade.repostLastUserMessage(conversationId);
        }
    }, [facade, conversationId]);

    const [[status], [title], [timestamp]] = useReadableEventRefresher(
        conversation.status,
        conversation.title,
        conversation.timestamp,
    );

    useEventRefresher(conversation.runs.itemsAdded, conversation.runs.itemIdChanged);

    return {
        conversation,
        runs: conversation?.runs.getOrderedItems(),
        status,
        postUserMessage,
        title: title ?? 'Untitled Conversation',
        timestamp,
        repostLastUserMessage,
    };
}
